import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Circle = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #505050;
  fill: #333;
  filter: drop-shadow(0px 4px 3px rgba(18, 18, 18, 0.03));
  color: #fafafa;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  z-index: 2;
  color: #fafafa;
`;

export const InitialsCircle = () => {
  const { first_name, last_name } = useSelector((state) => state.login.loguedAs);
  const initials = (first_name.charAt(0) + last_name.charAt(0)).toUpperCase();

  return <Circle>{initials}</Circle>;
};

export default InitialsCircle;
